/* eslint-disable jsx-a11y/no-redundant-roles */
/* eslint-disable consistent-return */
/* eslint-disable react/no-did-mount-set-state */
/* eslint-disable react/no-unused-state */
/* eslint-disable camelcase */
import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import DescripcionCheckout from './paquetes-checkout-descripcion';
import ResumenPaquete from './paquetes-checkout-resumen/paquetes-checkout-resumen';
import DetallePaquete from './paquetes-checkout-detalle/paquetes-checkout-detalle';
import Asesor from './paquetes-checkout-asesor/paquetes-checkout-asesor';
import FormasPago from './paquetes-checkout-formas-pago/paquetes-checkout-formas-pago';
import Pasajeros from './paquetes-checkout-pasajeros/paquetes-checkout-pasajeros';
import DatosFacturacion from './paquetes-checkout-datos-facturacion/paquetes-checkout-datos-facturacion';
import DatosContacto from './paquetes-checkout-datos-contacto/paquetes-checkout-datos-contacto';
import TerminosYcondiciones from './paquetes-checkout-terminos-condiciones/paquetes-checkout-terminos-condiciones';
import interesesPagos from '../../api/intereses-medios-pago';
import './paquete-checkout-contenido.css';
import PaquetesClient from '../../api/paquetes';
import Nacionalidades from '../../api/nacionalidades';
// import ReactGA from "react-ga";
import CityName from '../../commons/iataRenderService';
import ClientePagos from '../../api/pagos';

class PaqueteCheckoutContenido extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _isMounted: false,
      formaPago: 'deposito',
      canalesPago: [],
      cuotas: '',
      importe: '',
      proveedorId: this.props.paquete.proveedorId,
      aplicacionId: props.application.applicationId,
      fareCode:
        this.props.paquete.proveedorId === 1
          ? this.props.paquete.salidas[0].id
          : this.props.paquete.salidas[0].referencia.externa !== ''
          ? this.props.paquete.salidas[0].referencia.externa
          : this.props.paquete.salidas[0].referencia.interna,
      origenId: this.props.paquete.salidas[0].origenIata,
      destinoId: this.props.paquete.salidas[0].destinoIata.includes(';')
        ? this.props.paquete.salidas[0].destinoIata.split(';')[1]
        : this.props.paquete.salidas[0].destinoIata,
      passengers: [],
      datos_facturacion: {
        nombre: '',
        apellido: '',
        tipo_documento: '',
        nro_documento: '',
        provincia: '',
        localidad: '',
        direccion: '',
        piso: '',
        departamento: '',
        telefono: '',
      },
      datos_contacto: {
        email: '',
        telefono: '',
      },
      uso_datos_pasajero_uno: false,
      recibir_ofertas_promociones: false,
      terminos_condiciones: false,
      porcentaje_cargos: 0,
      localitiesFiltered: [],
      datosAsesor: '',
      destination: {
        country_name: null,
      },
    };

    this.actualizarFormaPago = this.actualizarFormaPago.bind(this);
    this.actualizarPorcentajeCargos = this.actualizarPorcentajeCargos.bind(this);
    this.actualizarPasajeros = this.actualizarPasajeros.bind(this);
    this.actualizarFechaNacimientoPasajeros = this.actualizarFechaNacimientoPasajeros.bind(this);
    this.setearStateInicialPasajeros = this.setearStateInicialPasajeros.bind(this);
    this.recorrerPasajeros = this.recorrerPasajeros.bind(this);
    this.setearPassengers = this.setearPassengers.bind(this);
    this.actualizarDatosContacto = this.actualizarDatosContacto.bind(this);
    this.actualizarCheckbox = this.actualizarCheckbox.bind(this);
    this.actualizarDatosFacturacion = this.actualizarDatosFacturacion.bind(this);
    this.utilizarDatosPasajeroUno = this.utilizarDatosPasajeroUno.bind(this);
    this.actualizarCuotas = this.actualizarCuotas.bind(this);
    this.onSubmitForm = this.onSubmitForm.bind(this);
    this.armarDatosPrereserva = this.armarDatosPrereserva.bind(this);
    this.obtenerAgencia = this.obtenerAgencia.bind(this);
    this.onProvinceChange = this.onProvinceChange.bind(this);
    this.onCityChange = this.onCityChange.bind(this);
    this.setearImporte = this.setearImporte.bind(this);
    this.actualizarVencimientoPasaporte = this.actualizarVencimientoPasaporte.bind(this);
    this.obtenerFormasPagoDeAplicacion = this.obtenerFormasPagoDeAplicacion.bind(this);
    this.armarDatosParaJulia = this.armarDatosParaJulia.bind(this);
  }

  componentDidMount() {
    this.setearStateInicialPasajeros();
    this.setearImporte();
    this.obtenerFormasPagoDeAplicacion();
    this.setState({ _isMounted: true });
  }

  componentWillUnmount() {
    this.setState({ _isMounted: false });
  }

  obtenerDatoUrl = (query) => {
    return new URLSearchParams(window.location.search).get(query);
  };

  obtenerFormasPagoDeAplicacion() {
    const { token } = this.props.application;
    ClientePagos.obtenerCanalesPagoAplicacion(token).then((res) => {
      const canalesPago = res.data;
      if (canalesPago !== null && canalesPago.length > 0) {
        this.setState({
          canalesPago,
          formaPago: canalesPago[0].canalPagoDescripcion,
        });
      }
    });
  }

  setearImporte() {
    const cantidadPasajeros =
      this.props.paquete.pasajeros !== null && this.props.paquete.pasajeros.length > 0
        ? this.props.paquete.pasajeros.length
        : this.props.cantidadPasajeros;
    const precioPersona = Math.ceil(
      this.props.paquete.salidas[0].precios.precioNeto / cantidadPasajeros,
    );
    const impuestosTasas = Math.ceil(
      this.props.paquete.salidas[0].precios.impuestos +
        this.props.paquete.salidas[0].precios.iva +
        this.props.paquete.salidas[0].precios.impuestoPais,
    );
    const totalPaqueteSinImpuestos = (impuestosTasas + precioPersona) * cantidadPasajeros;

    const cargos = Math.ceil(
      totalPaqueteSinImpuestos / ((100 - this.state.porcentaje_cargos) / 100) -
        totalPaqueteSinImpuestos,
    );
    const total = cargos + totalPaqueteSinImpuestos;
    this.setState({
      importe: total,
    });
    return total;
  }

  actualizarFormaPago(event) {
    this.setState({
      formaPago: event.target.value,
      datosAsesor: '',
    });
    this.actualizarPorcentajeCargos(event.target.value);

    this.obtenerAgencia(true);
  }

  actualizarPorcentajeCargos(formaPago) {
    switch (formaPago) {
      case 'deposito':
        this.setState({
          porcentaje_cargos: 0,
          cuotas: 0,
        });
        break;
      default:
        for (let indice = 0; indice < interesesPagos.length; indice++) {
          if (
            interesesPagos[indice].metodo_pago === formaPago.toLowerCase() &&
            interesesPagos[indice].cuotas === 1
          ) {
            this.setState({
              porcentaje_cargos: interesesPagos[indice].porcentaje,
              cuotas: 1,
            });
            return;
          }
        }
        break;
    }
  }

  actualizarCuotas(event) {
    for (let indice = 0; indice < interesesPagos.length; indice++) {
      if (
        parseInt(interesesPagos[indice].cuotas) === parseInt(event.target.value) &&
        interesesPagos[indice].metodo_pago === this.state.formaPago.toLowerCase()
      ) {
        this.setState({
          cuotas: event.target.value,
          porcentaje_cargos: interesesPagos[indice].porcentaje,
        });
      }
    }
  }

  onProvinceChange(newValue) {
    const localitiesFiltered = this.props.localities.filter(
      (city) => city.provinciaId === parseInt(newValue),
    );

    this.setState((prevState) => ({
      datos_facturacion: {
        ...prevState.datos_facturacion,
        provincia: newValue,
      },
      localitiesFiltered,
    }));
  }

  onCityChange(newValue) {
    this.setState((prevState) => ({
      datos_facturacion: {
        ...prevState.datos_facturacion,
        localidad: newValue,
      },
    }));

    if (parseInt(this.props.applicationType) === 1) {
      // derivadora
      this.obtenerAgencia();
    }
  }

  obtenerAgencia() {
    const datos = {
      provinciaId: this.state.datos_facturacion.provincia,
      localidadId: this.state.datos_facturacion.localidad,
      appId: this.state.aplicacionId,
      paisId: this.props.countryId,
      tipoAccion: 2, // venta
    };
    const { token } = this.props.application;
    const agencia = false;

    if (this.state.datos_facturacion.provincia !== '' && datos.appId === '1') {
      PaquetesClient.obtenerAgencia(datos, token).then((res) => {
        if (res.status === 200) {
          this.setState({
            datosAsesor: res.data,
          });
          return res;
        }
      });
    }

    return agencia;
  }

  setearStateInicialPasajeros() {
    for (let habitacion = 0; habitacion < this.props.habitaciones.length; habitacion++) {
      this.recorrerPasajeros('ADL', this.props.habitaciones[habitacion].adultos, habitacion + 1);
      this.recorrerPasajeros(
        'CHD',
        this.props.habitaciones[habitacion].menores.length,
        habitacion + 1,
      );
    }
  }

  recorrerPasajeros(tipoPasajero, cantidad, numeroHabitacion) {
    for (let pasajero = 1; pasajero <= cantidad; pasajero++) {
      this.setearPassengers(tipoPasajero, numeroHabitacion);
    }
  }

  setearPassengers(tipoPasajero, nroHabitacion) {
    this.state.passengers.push({
      type: tipoPasajero,
      age: '',
      documentType: '',
      documentNumber: '',
      documentTypeAfip: '',
      documentNumberAfip: '',
      passportExpirationDate: '',
      passportExpirationDay: '',
      passportExpirationMonth: '',
      passportExpirationYear: '',
      gender: '',
      birthDate: '2017-01-01',
      lastName: '',
      firstName: '',
      nationality: 'AR',
      residence: 'AR',
      birthDay: '01',
      birthMonth: '01',
      birthYear: '2017',
      roomNumber: nroHabitacion,
    });
  }

  actualizarPasajeros(event) {
    const { passengers } = this.state;

    passengers[[event.target.getAttribute('data-indice')]][event.target.getAttribute('data-name')] =
      event.target.value;

    this.setState({
      passengers,
    });
  }

  actualizarFechaNacimientoPasajeros(event) {
    const { passengers } = this.state;

    passengers[[event.target.getAttribute('data-indice')]][event.target.getAttribute('data-name')] =
      event.target.value;
    this.setState({ passengers });

    const diaNacimiento = passengers[[event.target.getAttribute('data-indice')]].birthDay !== '';
    const mesNacimiento = passengers[[event.target.getAttribute('data-indice')]].birthMonth !== '';
    const anioNacimiento = passengers[[event.target.getAttribute('data-indice')]].birthYear !== '';

    if (diaNacimiento && mesNacimiento && anioNacimiento) {
      passengers[[event.target.getAttribute('data-indice')]].birthDate = `${
        passengers[[event.target.getAttribute('data-indice')]].birthYear
      }-${passengers[[event.target.getAttribute('data-indice')]].birthMonth}-${
        passengers[[event.target.getAttribute('data-indice')]].birthDay
      }`;
      this.setState({ passengers });

      passengers[[event.target.getAttribute('data-indice')]].age = moment().diff(
        moment(passengers[[event.target.getAttribute('data-indice')]].birthDate).format(
          'DD-MM-YYYY',
        ),
        'years',
      );
      this.setState({ passengers });
    }
  }

  actualizarVencimientoPasaporte(event) {
    const { passengers } = this.state;

    passengers[[event.target.getAttribute('data-indice')]][event.target.getAttribute('data-name')] =
      event.target.value;

    const dia = passengers[[event.target.getAttribute('data-indice')]].passportExpirationDay !== '';
    const mes =
      passengers[[event.target.getAttribute('data-indice')]].passportExpirationMonth !== '';
    const anio =
      passengers[[event.target.getAttribute('data-indice')]].passportExpirationYear !== '';

    if (dia && mes && anio) {
      passengers[[event.target.getAttribute('data-indice')]].passportExpirationDate = `${
        passengers[[event.target.getAttribute('data-indice')]].passportExpirationYear
      }-${passengers[[event.target.getAttribute('data-indice')]].passportExpirationMonth}-${
        passengers[[event.target.getAttribute('data-indice')]].passportExpirationDay
      }`;
    }

    this.setState({ passengers });
  }

  actualizarCheckbox(event) {
    const value = document.getElementById(event.target.id).checked === true;

    this.setState({
      [event.target.getAttribute('data-name')]: value,
    });
  }

  actualizarDatosContacto(event) {
    const { datos_contacto } = this.state;

    datos_contacto[event.target.getAttribute('data-name')] = event.target.value;

    this.setState({
      datos_contacto,
    });
  }

  actualizarDatosFacturacion(event) {
    const { datos_facturacion } = this.state;

    datos_facturacion[event.target.getAttribute('data-name')] = event.target.value;

    this.setState({
      datos_facturacion,
    });
  }

  utilizarDatosPasajeroUno(event) {
    const { datos_facturacion } = this.state;

    const isChecked = document.getElementById(event.target.id).checked === true;

    if (isChecked) {
      document.getElementById('nombre-facturacion').value = this.state.passengers[0].firstName;
      document.getElementById('apellido-facturacion').value = this.state.passengers[0].lastName;
      document.getElementById('tipo-documento-facturacion').value =
        this.state.passengers[0].documentType;
      document.getElementById('numero-documento-facturacion').value =
        this.state.passengers[0].documentNumber;
      datos_facturacion.nombre = this.state.passengers[0].firstName;
      datos_facturacion.apellido = this.state.passengers[0].lastName;
      datos_facturacion.tipo_documento = this.state.passengers[0].documentType;
      datos_facturacion.nro_documento = this.state.passengers[0].documentNumber;
    } else {
      datos_facturacion.nombre = '';
      datos_facturacion.apellido = '';
      datos_facturacion.tipo_documento = '';
      datos_facturacion.nro_documento = '';
      document.getElementById('nombre-facturacion').value = '';
      document.getElementById('apellido-facturacion').value = '';
      document.getElementById('tipo-documento-facturacion').value = '';
      document.getElementById('numero-documento-facturacion').value = '';
    }

    this.setState({
      datos_facturacion,
      uso_datos_pasajero_uno: isChecked,
    });
  }

  onSubmitForm(event) {
    event.preventDefault();
    // ReactGA.event({
    //   category: "Accion",
    //   action: "Compra",
    //   label: "Paquetes",
    //   nonInteraction: true,
    // });
    this.setearImporte();
    document.getElementById('confirmacionCompra').setAttribute('disabled', 'true');
    const datosPrereserva = this.armarDatosPrereserva();
    const { token } = this.props.application;
    this.props.setearPreloader();
    PaquetesClient.createLog(datosPrereserva, token).then((res) => {});
    PaquetesClient.reservar(datosPrereserva, token).then((res) => {
      if (res.status === 200) {
        window.location.replace(res.data.urlRedireccion);
        if (this.state._isMounted === true) {
          this.setState({
            reservaOK: res.data.urlRedireccion,
            creandoReserva: false,
          });
        }
      } else {
        if (this.state._isMounted === true) {
          this.setState({ cupos: false });
        }
        this.props.setearError('No se pudo completar la reserva correctamente');
      }
    });
  }

  armarDatosParaJulia() {
    const nroGrupo =
      this.props.paquete.salidas[0].hoteles.length > 0
        ? this.props.paquete.salidas[0].hoteles[0].nroGrupo ||
          this.props.paquete.salidas[0].hoteles[0].nroGrupo !== null
          ? this.props.paquete.salidas[0].hoteles[0].nroGrupo
          : 0
        : 0;
    return {
      idpaquete: this.props.paquete.id,
      nrogrupo: nroGrupo,
      ocupacion: this.obtenerDatoUrl('h'),
      fechainicio: moment(this.props.paquete.salidas[0].fechaSalida).format('YYYY-MM-DD'),
    };
  }

  armarDatosPrereserva() {
    const url = new URL(window.location.href);
    const monedaId = this.props.paquete.salidas[0].precios.moneda === 'USD' ? 2 : 1;
    const juliaInfo = this.armarDatosParaJulia();
    return {
      dominioOrigen: window.location.hostname,
      fareCode: this.state.fareCode,
      aplicacionId: this.state.aplicacionId,
      proveedorId: this.state.proveedorId,
      origenId: this.state.origenId,
      destinoId: this.state.destinoId,
      passengers: this.state.passengers,
      distribucion: url.searchParams.get('h'),
      importe: this.setearImporte(),
      formaPago: this.state.formaPago,
      cuotas: this.state.cuotas,
      porcentaje_cargos: this.state.porcentaje_cargos,
      datosAsesor: this.state.datosAsesor,
      datos_facturacion: this.state.datos_facturacion,
      datos_contacto: this.state.datos_contacto,
      pythagoras_info: this.props.paquete,
      julia_info: juliaInfo,
      moneda_id: monedaId,
    };
  }

  render() {
    const { t } = this.props;
    const ciudadOrigen = (
      <CityName code={this.props.paquete.salidas[0].origenIata} upperCase="true" />
    );

    let queryString = '?type=Paquete';
    const url_string = window.location.href;
    const url = new URL(url_string);
    queryString = `${'?type=Paquete&h='}${url.searchParams.get(
      'h',
    )}&referencia=${url.searchParams.get('t')}&proveedorId=${url.searchParams.get('p')}`;

    const formasPago =
      this.state.canalesPago.length > 0 ? (
        <FormasPago
          actualizarCuotas={this.actualizarCuotas}
          formaPago={this.state.formaPago}
          canalesPago={this.state.canalesPago}
          paquete={this.props.paquete}
          precio={this.state.importe}
          actualizarFormaPago={this.actualizarFormaPago}
        />
      ) : (
        <div className="alert alert-danger" role="alert">
          {' '}
          <a href={`${process.env.RAZZLE_URL}/consulta${queryString}`} target="blank">
            {t('checkout.noPayment')}
          </a>
        </div>
      );

    const confirmarReserva =
      this.state.canalesPago.length > 0 ? (
        <div>
          <TerminosYcondiciones actualizarCheckbox={this.actualizarCheckbox} />
          <div className="btn">
            <button
              type="submit"
              id="confirmacionCompra"
              className="bg-red-500 hover:bg-red-700 text-lg font-bold text-white mb-2 px-14 py-2 rounded-md my-5 hover:bg-light-blue-500"
            >
              {this.state.formaPago === 'deposito' ? t('checkout.book') : t('checkout.buy')}
            </button>
          </div>
        </div>
      ) : (
        ''
      );

    return (
      <div className="paquetes checkout">
        <div className="container">
          <DescripcionCheckout
            nombre={
              parseInt(this.props.paquete.proveedorId) === 10
                ? this.props.paquete.nombre.replace(/\((.*?)\)/g, '')
                : this.props.paquete.nombre
            }
            salida={ciudadOrigen}
            pasajeros={this.props.cantidadPasajeros}
          />
          <h2 className="text-2xl font-color-mbr-color-primario mb-2">
            <b>{t('checkout.title1')}</b> {t('checkout.title2')}
          </h2>
          <div className="grid-cols-3 md:grid">
            <div className="col-span-2">
              <form
                id="form-checkout"
                onSubmit={this.onSubmitForm}
                className="form-style-neutro"
                data-toggle="validator"
                role="form"
              >
                <Pasajeros
                  nacionalidades={Nacionalidades}
                  pasajeros={this.state.passengers}
                  actualizarFechaNacimientoPasajeros={this.actualizarFechaNacimientoPasajeros}
                  actualizarPasajeros={this.actualizarPasajeros}
                  actualizarVencimientoPasaporte={this.actualizarVencimientoPasaporte}
                  habitaciones={this.props.habitaciones}
                  proveedorId={this.state.proveedorId}
                />
                <DatosFacturacion
                  localities={this.state.localitiesFiltered}
                  onCityChange={this.onCityChange}
                  onProvinceChange={this.onProvinceChange}
                  datos_facturacion={this.state.datos_facturacion}
                  utilizarDatosPasajeroUno={this.utilizarDatosPasajeroUno}
                  actualizarDatosFacturacion={this.actualizarDatosFacturacion}
                />
                <DatosContacto
                  actualizarCheckbox={this.actualizarCheckbox}
                  actualizarDatosContacto={this.actualizarDatosContacto}
                />

                {formasPago}
                {confirmarReserva}
              </form>
            </div>
            <div className="col-span-1 px-4">
              <ResumenPaquete
                porcentajeCargos={this.state.porcentaje_cargos}
                habitaciones={this.props.habitaciones}
                paquete={this.props.paquete}
                cantidadPasajeros={this.props.cantidadPasajeros}
                origen={ciudadOrigen}
                formaPago={this.state.formaPago}
                metodosDePago={this.state.canalesPago}
              />
              <DetallePaquete
                porcentajeCargos={this.state.porcentaje_cargos}
                habitaciones={this.props.habitaciones}
                paquete={this.props.paquete}
                cantidadPasajeros={this.props.cantidadPasajeros}
                origen={ciudadOrigen}
              />
              {this.state.datosAsesor.length === 0 ? null : (
                <Asesor datosAsesor={this.state.datosAsesor} />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  application: state.applicationState,
  packagesDestination: state.packages.ciudadDestino,
  applicationType: parseInt(state.applicationState.tipoAplicacionId),
  countryId: parseInt(state.applicationState.paisId),
  localities: state.applicationState.geo.localities.data || [],
});

export default connect(
  mapStateToProps,
  null,
)(withTranslation(['translations'])(PaqueteCheckoutContenido));
